export default __webpack_public_path__ + "static/media/hampton_inn_middletown.f5f594c0.jpg";